<modal [title]="title" [tagEventImp]="tagEventImp" [tagEventCTA]="tagEventCTA" [tagEventClose]="tagEventClose">
    <p class="text is-marginless">Rassurez-vous, nos équipes sont sur le coup !</p>
    <p class="text">Vous pouvez retenter votre chance ou réessayer un peu plus tard.</p>
    <ng-template #customModalFooter>
        <button class="button is-conversion" (click)="close()">Recommencer</button>
    </ng-template>
</modal>
